import React from "react";

const Dashboard = () => {
  return (
    <main className="box">
      <div className="app-content">Refer menu to browse respective module</div>
    </main>
  );
};

export default Dashboard;